const openBtn = document.querySelector(".open-comparison-table");
if (openBtn)
  openBtn.addEventListener("click", () => {
    if (openBtn.getAttribute("data-has-been-toggled")) return;
    const title = openBtn.getAttribute("data-title");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "clickComparisonTable",
      product: title,
    });
    openBtn.setAttribute("data-has-been-toggled", "true");
  });
